import React, {useState, useEffect, ReactNode} from 'react';

interface LayoutProps {
    children: ReactNode;
    buttonTrigger: ReactNode;
    forceModalClose?: null | boolean;
    onSetForceModalClose?: (state:any) => void,
}

const SideSlidingModal = ({children, buttonTrigger, forceModalClose = null, onSetForceModalClose}: LayoutProps) => {


    const [isAnimating, setIsAnimating] = useState<boolean>(false);
    
    const [openModal, setOpenModal] = useState<boolean>(false);

    useEffect(() => {
        if (openModal) {
        document.body.style.overflow = 'hidden';
        setIsAnimating(true);
        } else {
        document.body.style.overflow = 'auto';
        }

        return () => {
        document.body.style.overflow = 'auto';
        };
    }, [openModal]);

    const handleClose = () => {
        
        setIsAnimating(false);
        setTimeout(() => {
            setOpenModal(false)
        }, 300);
        
    };

    useEffect(() => {
        forceModalClose ? setOpenModal(!openModal) : handleClose();
    }, [forceModalClose]);

    // useEffect(() => {
    //     const e = document.getElementById('modal')
    //     if (e) e.scrollTop = 0
    //   }, [forceModalClose])

    return (
        <div className='relative'>
            <div onClick={() => onSetForceModalClose ? onSetForceModalClose(true) : setOpenModal(true)}>
                {buttonTrigger} 
            </div>
            
             <div id='modal' className={`${isAnimating ? 'translate-x-0' : 'translate-x-full' } bg-[#F8F8F8] p-10  fixed transition-transform duration-500 transform right-0 lg:w-[45%] w-full top-0 h-full z-40 overflow-y-auto`}>
             <button type='button' onClick={() => onSetForceModalClose ? onSetForceModalClose(false) : handleClose()} className={`fixed z-50 top-6 opacity-100 right-8 ${isAnimating ? 'opacity-100' : 'opacity-0'}`}>
            <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M22.8844 12.8844L18.7672 17L22.8844 21.1156C23.0005 21.2318 23.0926 21.3696 23.1555 21.5214C23.2184 21.6731 23.2507 21.8358 23.2507 22C23.2507 22.1642 23.2184 22.3269 23.1555 22.4786C23.0926 22.6304 23.0005 22.7682 22.8844 22.8844C22.7682 23.0005 22.6304 23.0926 22.4786 23.1555C22.3269 23.2183 22.1643 23.2507 22 23.2507C21.8358 23.2507 21.6731 23.2183 21.5214 23.1555C21.3696 23.0926 21.2318 23.0005 21.1156 22.8844L17 18.7672L12.8844 22.8844C12.7682 23.0005 12.6304 23.0926 12.4786 23.1555C12.3269 23.2183 12.1643 23.2507 12 23.2507C11.8358 23.2507 11.6731 23.2183 11.5214 23.1555C11.3696 23.0926 11.2318 23.0005 11.1156 22.8844C10.9995 22.7682 10.9074 22.6304 10.8445 22.4786C10.7817 22.3269 10.7493 22.1642 10.7493 22C10.7493 21.8358 10.7817 21.6731 10.8445 21.5214C10.9074 21.3696 10.9995 21.2318 11.1156 21.1156L15.2328 17L11.1156 12.8844C10.8811 12.6498 10.7493 12.3317 10.7493 12C10.7493 11.6683 10.8811 11.3502 11.1156 11.1156C11.3502 10.8811 11.6683 10.7493 12 10.7493C12.3317 10.7493 12.6498 10.8811 12.8844 11.1156L17 15.2328L21.1156 11.1156C21.2318 10.9995 21.3696 10.9074 21.5214 10.8445C21.6731 10.7817 21.8358 10.7493 22 10.7493C22.1643 10.7493 22.3269 10.7817 22.4786 10.8445C22.6304 10.9074 22.7682 10.9995 22.8844 11.1156C23.0005 11.2318 23.0926 11.3696 23.1555 11.5214C23.2184 11.6731 23.2507 11.8358 23.2507 12C23.2507 12.1642 23.2184 12.3269 23.1555 12.4786C23.0926 12.6304 23.0005 12.7682 22.8844 12.8844ZM33.25 17C33.25 20.2139 32.297 23.3557 30.5114 26.028C28.7258 28.7003 26.1879 30.7831 23.2186 32.013C20.2493 33.243 16.982 33.5648 13.8298 32.9378C10.6776 32.3107 7.78213 30.7631 5.50952 28.4905C3.23692 26.2179 1.68926 23.3224 1.06225 20.1702C0.435237 17.018 0.757041 13.7507 1.98696 10.7814C3.21689 7.81209 5.29969 5.27419 7.97199 3.48862C10.6443 1.70305 13.7861 0.75 17 0.75C21.3084 0.75455 25.439 2.46806 28.4855 5.51454C31.5319 8.56102 33.2455 12.6916 33.25 17ZM30.75 17C30.75 14.2805 29.9436 11.6221 28.4327 9.36091C26.9218 7.09973 24.7744 5.33736 22.2619 4.29666C19.7494 3.25595 16.9848 2.98366 14.3175 3.5142C11.6503 4.04475 9.20026 5.35431 7.27729 7.27728C5.35432 9.20025 4.04476 11.6503 3.51421 14.3175C2.98366 16.9847 3.25596 19.7494 4.29666 22.2619C5.33737 24.7744 7.09974 26.9218 9.36092 28.4327C11.6221 29.9436 14.2805 30.75 17 30.75C20.6455 30.7459 24.1404 29.2959 26.7182 26.7182C29.2959 24.1404 30.7459 20.6455 30.75 17Z" fill="#888888"/>
            </svg>
            </button>
                {children}
            </div>
            {openModal && <div onClick={() => onSetForceModalClose ? onSetForceModalClose(false) : handleClose()} className='fixed inset-0 top-0 left-0 z-30 w-full h-full py-10 bg-[rgba(0,0,0,0.5)]'></div>}
        </div>
    );
};

export default SideSlidingModal